// src/components/firebase.config.js
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  doc,
  setDoc,
  updateDoc,
  query,
  collection,
  limit,
  onSnapshot,
  deleteDoc,
  addDoc,
  Timestamp,
  getDocs,
  orderBy,
  startAfter,
  where,
  getDoc,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import {
  getAuth,
  GoogleAuthProvider,
  GithubAuthProvider,
  FacebookAuthProvider,
  updateProfile,
  RecaptchaVerifier,
  signInWithPopup,
  signInWithPhoneNumber,
  createUserWithEmailAndPassword,
  PhoneAuthProvider,
  signInWithCredential,
  signOut,
} from "firebase/auth";

// --- Firebase Config ---
const firebaseConfig = {
  apiKey: process.env.REACT_APP_DB_API_KEY,
  authDomain: process.env.REACT_APP_DB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_DB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_DB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

console.log("Firebase Config:", firebaseConfig);

// --- Initialize App ---
const app = initializeApp(firebaseConfig);

// --- Services ---
const auth = getAuth(app);
auth.useDeviceLanguage();

const firestore = getFirestore(app);
const storage = getStorage(app);

// --- Providers ---
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
});

const githubProvider = new GithubAuthProvider();
const facebookProvider = new FacebookAuthProvider();

// --- Re-exports ---
export {
  auth,
  firestore,
  storage,
  googleProvider,
  githubProvider,
  facebookProvider,
  RecaptchaVerifier,
  signInWithPopup,
  signInWithPhoneNumber,
  createUserWithEmailAndPassword,
  PhoneAuthProvider,
  signInWithCredential,
  updateProfile,
  signOut,
  firebaseConfig,
  doc,
  deleteDoc,
  limit,
  onSnapshot,
  collection,
  query,
  addDoc,
  Timestamp,
  getDocs,
  orderBy,
  startAfter,
  where,
  updateDoc,
  setDoc,
  getDoc,
  writeBatch,
  serverTimestamp,
  uploadBytes,
  getDownloadURL,
  storageRef,
};

export default app;